// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-single-card-in-slide {
  position: relative;
  width: 100%;
  max-width: 174px;
  height: auto;
  padding: 0;
}
.wrapper-single-card-in-slide .content-card {
  padding: 10px;
}
.wrapper-single-card-in-slide .card-title {
  color: #383838;
  font-weight: 700;
  font-size: 13px;
  line-height: 110%;
  letter-spacing: 0%;
  vertical-align: middle;
}
.wrapper-single-card-in-slide .card-description {
  color: #646466;
  font-weight: 500;
  font-style: Medium;
  font-size: 11px;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: middle;
  margin-bottom: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/single-card-in-slide/single-card-in-slide.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AACF;AAwCA;EACE,aAAA;AAtCF;AAwCA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAtCF;AAwCA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAtCF","sourcesContent":[".wrapper-single-card-in-slide {\n  position: relative;\n  width: 100%;\n  max-width: 174px;\n  height: auto;\n  padding: 0;\n  //border-top: 1px solid #DADADA;\n  //border-bottom: 1px solid #DADADA;\n  // padding-bottom: 10px;\n  //  &::before,\n  //  &::after {\n  //    position: absolute;\n  //    content: '';\n  //    width: 10px;\n  //    height: calc(100% - 10px);\n  //  }\n  //  &::before {\n  //    left: -11px;\n  //    bottom: -1px;\n  //    border-left: 1px solid #DADADA;\n  //    border-bottom: 1px solid #DADADA;\n  //}\n  //  &::after {\n  //    right: -11px;\n  //    top: -1px;\n  //    border-top: 1px solid #DADADA;\n  //    border-right: 1px solid #DADADA;\n  //}\n// .corner {\n//   position: absolute;\n//   width: 15px;\n//   height: 15px;\n//   transform: rotate(45deg);\n// }\n\n// .left {\n//   top: 2px;\n//   left: -8px;\n//   border-left: 1px solid #DADADA;\n// }\n\n// .right {\n//   bottom: 2px;\n//   right: -8px;\n//   border-right: 1px solid #DADADA;\n// }\n.content-card {\n  padding: 10px;\n}\n.card-title {\n  color: #383838;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 110.00000000000001%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n}\n.card-description {\n  color: #646466;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 11px;\n  line-height: 130%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n  margin-bottom: 25px;\n}\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
